import React, { FunctionComponent, PropsWithChildren } from 'react';

import { getWordbreakCss } from '../lib/css';

export const BreakableTitle: FunctionComponent<PropsWithChildren> = ({
  children,
}) => <h2 css={getWordbreakCss()}>{children}</h2>;
